query Product(
    $id: ID!
) {
    product(id: $id) {
        id

        metadata {
            createdAt
            archived
        }

        recordedBy(origin: brand) {
            data {
                brand

                name {
                    language
                    text
                }
                about {
                    language
                    text
                }
                materialName {
                    language
                    text
                }

                bimClass

                properties {
                    parameter
                    value
                    unit
                }

                components {
                    componentType
                    product
                    quantity
                    unitOfMeasurement
                    properties {
                        parameter
                        value
                        unit
                    }
                }
                layers {
                    componentType
                    properties {
                        parameter
                        value
                        unit
                    }
                }
                materials {
                    materialIdentifier
                    properties {
                        parameter
                        value
                        unit
                    }
                }

                media {
                    language
                    name
                    type
                    url
                }

                countries
            }

            metadata {
                updatedAt

                archived
                deleted
                published

                naturalKey
                tags
            }
        }
    }
}
